import { OpenAPI } from '../app/api/core/OpenAPI';

/**
 * Initialize OpenAPI configuration
 * Sets the BASE URL from environment variables
 * 
 * Note: If using a proxy (setupProxy.js), use relative URLs
 * Otherwise, use the full API base URL
 */
export function initializeApiConfig() {
    // Get API base URL from environment variable or use default
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5002';

    // Remove any quotes, commas, and whitespace from anywhere in the URL
    // Also remove trailing slashes to avoid double slashes when paths are appended
    const cleanUrl = apiBaseUrl
        .trim()
        .replace(/["',]/g, '') // Remove all quotes and commas
        .replace(/\/+$/, ''); // Remove trailing slashes

    // Use the full URL - backend must allow CORS from localhost:3000
    OpenAPI.BASE = cleanUrl;

    // For CORS to work properly
    // WITH_CREDENTIALS should be true if backend requires credentials
    OpenAPI.WITH_CREDENTIALS = false;
    OpenAPI.CREDENTIALS = 'include';

    console.log('API Base URL configured:', OpenAPI.BASE);
    console.log('Environment:', process.env.NODE_ENV || 'development');
}

// Initialize on import
initializeApiConfig();

